import { Button } from "@design";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import type { BuildEntity } from "./examplePrompts";

/** A list page's "Build with AI": the build chat, set up for that kind of entity. */
export function BuildWithAiButton({ entity }: Readonly<{ entity: BuildEntity }>) {
  const { t } = useTranslation("build");
  const navigate = useNavigate();
  return (
    <Button
      variant="secondary"
      leadingIcon={<Sparkles size={16} />}
      onClick={() => navigate(`/build/with-ai?entity=${entity}`)}
    >
      {t("withAi.title")}
    </Button>
  );
}
